module.exports = __webpack_public_path__ + "static/media/Celesteela_gaussian2.3c2482de.png";